import { Injectable, inject } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '@environments/environment';

@Injectable({providedIn: 'root'})
export class ImpressionService {
  private http = inject(HttpClient);

  private baseApiUrl = environment.apiUrl;
  private reportUrl = this.baseApiUrl + '/api/v1/project';

  report(projectId: number, params: any = {}) {
    return this.http.get(`${this.reportUrl}/${projectId}/report`, {params, headers: new HttpHeaders().set('Use-Temp-Token', 'true')});
  }

  exportAdvocatesReport(projectId: number, params: any = {}) {
    return this.http.get(`${this.reportUrl}/report/advocates_export/${projectId}`, {params, headers: new HttpHeaders().set('Use-Temp-Token', 'true')});
  }

  reportConversions(projectId: number, params: any = {}) {
    return this.http.get(`${this.reportUrl}/${projectId}/report/conversions`, {params, headers: new HttpHeaders().set('Use-Temp-Token', 'true')});
  }

  exportConversionsReport(projectId: number, params: any = {}) {
    return this.http.get(`${this.reportUrl}/report/conversions_export/${projectId}`, {params, headers: new HttpHeaders().set('Use-Temp-Token', 'true')});
  }

  reportPassword(projectId: number, password: string) {
    return this.http.post(`${this.reportUrl}/${projectId}/report/validate_password`, {password}, {
      headers: new HttpHeaders().set('Skip-auth', 'true')
    });
  }
}
